import { AxiosError } from 'axios';
import { AxiosErrorData } from '@/types/common';

export const formatAxiosError = (error: AxiosError<AxiosErrorData>, operation: string): Error => {
  if (error.response) {
    // Server responded with error status
    const { status, data } = error.response;
    const message = data?.message || `HTTP ${status}: ${error.message}`;
    return new Error(`${operation} failed: ${message}`);
  } else if (error.request) {
    // Request was made but no response received
    return new Error(`${operation} failed: Network error - no response received`);
  } else {
    // Something happened in setting up the request
    return new Error(`${operation} failed: ${error.message}`);
  }
};
